module.exports = __webpack_public_path__ + "static/media/marielle.fd5dd744.jpg";